import { observer } from "mobx-react";
import { NumberQuestion } from "@/dbot/common/commonComponents";
import { Grid, GridItem, VBox } from "@/components-v2/Box";
import { FC, Fragment } from "react";
import {
  ContributionPerShareTypeModel,
  IncreaseOfShareCapitalForm,
} from "./increaseOfShareCapitalDomain";
import { CURRENCY_NOK } from "@/utils/currency";
import { useTranslation } from "@/stores/RootStoreContext";
import { findShareTypeName, shareTypeLabel, sortByShareType } from "@/common/share";
import { MTextInput } from "@/components-v2/TextInput";

export const IncreaseContributionPerShare: FC<{ model: ContributionPerShareTypeModel }> = observer(
  ({ model }) => {
    const { t, lang } = useTranslation();
    return (
      <>
        <NumberQuestion
          question={t(
            "decisions.increaseShareCapitalAgainstCash.increaseNominalValue.shareContribution",
            {
              shareClassName: findShareTypeName(model.shareType, lang),
            },
          )}
          prefix={CURRENCY_NOK}
          field={model.contributionPerShare}
          isLocked={model.isProjectLocked}
        />
      </>
    );
  },
);

export const IncreaseNominalValueShareContribution: FC<{
  form: IncreaseOfShareCapitalForm;
}> = observer(({ form }) => {
  return (
    <VBox>
      {sortByShareType(
        form.increaseNominalValue.contributionPerShareTypes,
        "shareType.shareTypeCode",
      ).map((s) => (
        <IncreaseContributionPerShare key={s.data.sharetypeId} model={s} />
      ))}
    </VBox>
  );
});

export const IncreaseNominalValueShareContribution2: FC<{
  form: IncreaseOfShareCapitalForm;
}> = observer(({ form }) => {
  const { t } = useTranslation();
  return (
    <Grid cols={4} alignItems={"center"}>
      <GridItem className={"font-bold"}>
        {t("decisions.increaseShareCapitalAgainstCash.increaseNominalValue.contribution")}
      </GridItem>
      <GridItem>
        {t("decisions.increaseShareCapitalAgainstCash.increaseNominalValue.perShare")}
      </GridItem>
      <GridItem justifySelf={"end"}>
        {t("decisions.increaseShareCapitalAgainstCash.increaseNominalValue.premium")}
      </GridItem>
      <GridItem justifySelf={"end"}>{t("total")}</GridItem>
      {sortByShareType(
        form.increaseNominalValue.contributionPerShareTypes,
        "shareType.shareTypeCode",
      ).map((s) => (
        <Fragment key={s.shareType.shareTypeCode}>
          <GridItem>{t(shareTypeLabel(s.shareType))}</GridItem>
          <GridItem>
            <MTextInput
              model={s.contributionPerShare}
              prefix={CURRENCY_NOK}
              disabled={s.isProjectLocked}
              message={""} // disable the message, shown below instead
            />
          </GridItem>
          <GridItem justifySelf={"end"}>{t(s.premium)}</GridItem>
          <GridItem justifySelf={"end"}>{t(s.total)}</GridItem>
          {s.contributionPerShare.error && (
            <>
              <GridItem />
              <GridItem colSpan={3} className={"color-error text-sm"}>
                {t(s.contributionPerShare.error)}
              </GridItem>
            </>
          )}
        </Fragment>
      ))}
    </Grid>
  );
});
